module.exports = __webpack_public_path__ + "a31a0e92ec9501bf50683f35fedc325c.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/feet/banana-peel.png
// module id = 2484
// module chunks = 0